import script from "./VideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoModal.vue?vue&type=script&setup=true&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=d385698a&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d385698a"]])

export default __exports__